import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
var CONTENT_QUERY_KEY = 'content';
var contentKeys = {
  allContent: [CONTENT_QUERY_KEY],
  content: function content(query) {
    return [CONTENT_QUERY_KEY, query];
  },
  contentLogs: function contentLogs(search) {
    return [CONTENT_QUERY_KEY, 'logs', search];
  },
  todoContent: function todoContent(type, page) {
    return [CONTENT_QUERY_KEY, 'todos', type, page].filter(Boolean);
  },
  savedContent: function savedContent(type, status, page) {
    return [CONTENT_QUERY_KEY, type, status, page].filter(Boolean);
  },
  historyContent: function historyContent(type, status, page) {
    return [CONTENT_QUERY_KEY, 'history', type, status, page].filter(Boolean);
  },
  sharedContent: [CONTENT_QUERY_KEY, 'shared']
};
export default contentKeys;